export default __webpack_public_path__ + "static/media/1-bg.9ba000e5.png";